/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Card_Actions_MenuInputs */



/**
* | output |
* | --- |
* | "Agent actions" |
*
* @param {Agent_Card_Actions_MenuInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_card_actions_menu = /** @type {((inputs?: Agent_Card_Actions_MenuInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Card_Actions_MenuInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Agent-Aktionen")
	return /** @type {LocalizedString} */ ("Agent actions")
});